


































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";

@Component
export default class Orientation extends Vue {
  private isPre2Batch = false;

  mounted() {
    localStorage[config.firstLogin] = 'true';

    if (
    localStorage[config.isPre2] &&
    localStorage[config.isPre2] !== "undefined"
  )
    this.isPre2Batch = JSON.parse(localStorage[config.isPre2]);
  }
}
